import { IBrandingOverrides } from 'src/branding/types';

interface Status {
  label: string;
  key?: string;
  value?: string;
  id: string;
}

export const filterAllowedStatus = (
  statuses: Status[],
  branding: IBrandingOverrides
) => {
  if (!branding.permissions.serviceRequestStatus.current) {
    return statuses;
  }
  return statuses.filter(
    (s) => branding.permissions.serviceRequestStatus.current[s.id] ?? true
  );
};
